import { render } from "./Lobby.vue?vue&type=template&id=ed3b863e&scoped=true"
import script from "./Lobby.vue?vue&type=script&lang=js"
export * from "./Lobby.vue?vue&type=script&lang=js"

import "./Lobby.vue?vue&type=style&index=0&id=ed3b863e&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3b863e"]])

export default __exports__